module.exports = __webpack_public_path__ + "static/media/nonetwork.493ed5fd.svg";